import React from "react";
import ArticleTable from "./List/IdeaList";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Users = () => {
  return (
    <div className="list">
      <div className="listContainer">
        <ArticleTable />
      </div>
    </div>
  );
};

export default Users;
